export default __webpack_public_path__ + "static/media/menu-item-vegetarian-icon.6df3910e.svg";